import React from 'react';
import { ErpDataTableV2 } from '@/components/custom/erp';
import CoQuanThueDialog from './components/coquanthue-dialog';
import { useCoQuanThue } from '@/hooks/queries/useCoQuanThue';
import { useDialogState, useRowSelection } from './hooks';
import { ActionBar, DeleteDialog } from './components';
import { getDataTableColumns } from './cols-definition';

export default function CoQuanThue() {
  const { coQuanThues, loading, addCoQuanThue, updateCoQuanThue, deleteCoQuanThue } = useCoQuanThue();
  const { selectedObj, selectedRowIndex, handleRowClick, clearSelection } = useRowSelection();
  const {
    showAddDialog,
    showEditDialog,
    showDeleteDialog,
    showWatchDialog,
    isCopyMode,

    openAddDialog,
    closeAddDialog,
    openEditDialog,
    closeEditDialog,
    openDeleteDialog,
    closeDeleteDialog,
    closeWatchDialog,

    handleAddButtonClick,
    handleEditButtonClick,
    handleDeleteButtonClick,
    handleCopyButtonClick
  } = useDialogState(clearSelection);

  const tables = [
    {
      name: 'Tất cả',
      rows: coQuanThues,
      columns: getDataTableColumns()
    }
  ];

  return (
    <div className='flex h-screen flex-col lg:overflow-hidden'>
      {(showAddDialog || showEditDialog) && (
        <CoQuanThueDialog
          open={showAddDialog || showEditDialog}
          mode={showEditDialog ? 'edit' : 'add'}
          initialData={
            selectedObj && showEditDialog
              ? {
                  ma_cqt: selectedObj.ma_cqt,
                  ten_cqt: selectedObj.ten_cqt,
                  ma_cqt0: selectedObj.ma_cqt0,
                  trang_thai: parseInt(selectedObj.status)
                }
              : selectedObj && showAddDialog && isCopyMode
                ? {
                    ma_cqt: selectedObj.ma_cqt,
                    ten_cqt: selectedObj.ten_cqt,
                    ma_cqt0: selectedObj.ma_cqt0,
                    trang_thai: parseInt(selectedObj.status)
                  }
                : undefined
          }
          onClose={showEditDialog ? closeEditDialog : closeAddDialog}
          selectedObj={showEditDialog ? selectedObj : null}
          addCoQuanThue={addCoQuanThue}
          updateCoQuanThue={updateCoQuanThue}
        />
      )}

      {showDeleteDialog && (
        <DeleteDialog
          open={showDeleteDialog}
          onClose={closeDeleteDialog}
          selectedObj={selectedObj}
          deleteCoQuanThue={deleteCoQuanThue}
          clearSelection={clearSelection}
        />
      )}

      {showWatchDialog && selectedObj && (
        <CoQuanThueDialog
          open={showWatchDialog}
          mode='view'
          initialData={{
            ma_cqt: selectedObj.ma_cqt,
            ten_cqt: selectedObj.ten_cqt,
            ma_cqt0: selectedObj.ma_cqt0,
            trang_thai: parseInt(selectedObj.status)
          }}
          onClose={closeWatchDialog}
          selectedObj={selectedObj}
          addCoQuanThue={addCoQuanThue}
          updateCoQuanThue={updateCoQuanThue}
          onAddButtonClick={handleAddButtonClick}
          onEditButtonClick={handleEditButtonClick}
          onDeleteButtonClick={handleDeleteButtonClick}
          onCopyButtonClick={handleCopyButtonClick}
        />
      )}

      <div className='w-full'>
        <ActionBar
          onAddClick={openAddDialog}
          onEditClick={() => selectedObj && openEditDialog()}
          onDeleteClick={() => selectedObj && openDeleteDialog()}
          onCopyClick={() => selectedObj && handleCopyButtonClick()}
        />

        <ErpDataTableV2
          tables={tables}
          selectedRowId={selectedRowIndex || undefined}
          onRowClick={handleRowClick}
          loading={loading}
        />
      </div>
    </div>
  );
}
